import { DocsBlockBuilder } from "../../../../../../tools/docs-block-builder/SDKDocsBlockBuilder";
import { DocsBlockCategory } from "../../../../../enums/SDKDocsBlockCategory";
const b = new DocsBlockBuilder();
/**
 * 1. Block metadata
 */
export const id = "io.supernova.block.embed";
export const name = "Embed";
export const icon = "https://cdn-assets.supernova.io/blocks/icons/embed.svg";
export const descriptionShort = "Embed a generic URL";
export const searchKeywords = ["embed", "url", "iframe", "site", "import"];
export const helpText = "Embed any page to your documentation as an iframe.";
export const docsUrl = "https://learn.supernova.io/latest/documentation/types-of-blocks/media-and-assets/embed/public-url-2ZeRQ332";
/**
 * 2. Block properties
 */
const properties = {
    embedUrl: b.embedUrlProperty({
        id: "embedUrl",
        name: "Embed URL",
        options: {
            allowCaption: true,
            allowResize: true,
            defaultHeight: 400,
            isInteractive: false,
            urlValidationRegex: "^(https?://)?(www.)?.+$",
        },
    }),
};
/**
 * 3. Block variants
 */
const defaultVariant = b.defaultVariantUsingDefaultLayout({
    properties: [properties.embedUrl],
});
/**
 * 4. Block item
 */
const blockItem = b.singleVariantItem({
    properties: [properties.embedUrl],
    variant: defaultVariant,
});
/**
 * 5. Block definition
 */
const block = b.singleItemBlock({
    id,
    name,
    icon,
    category: DocsBlockCategory.media,
    description: descriptionShort,
    item: blockItem,
    searchKeywords,
    onboarding: b.onboarding({
        helpText,
        documentationLink: docsUrl,
    }),
});
/** 6. Block export */
export { block as Embed };
